import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["datetime"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("time", { datetime: _ctx.val }, _toDisplayString(_ctx.formatted), 9 /* TEXT, PROPS */, _hoisted_1))
}